<nb-radio-group [disabled]="disabled" [name]="controlName" [(value)]="value" [formControlName]="controlName">
  <nb-radio *ngFor="let item of list" [value]="item.value" [ngClass]="{'d-inline': inLine}">
    {{ item.display }}
  </nb-radio>
</nb-radio-group>
